enum NodeCategories {
	Direction = "Direction",
	Element = "Element",
	Force = "Force",
	Modifier = "Modifier",
	Event = "Event",
	Logistics = "Logistics",
	Targeting = "Targeting",
	Unique = "Unique"
}

export default NodeCategories;